
// Combining Zalgo marks
const zalgoMarks = [
  '\u0300', '\u0301', '\u0302', '\u0303', '\u0304', '\u0305',
  '\u0306', '\u0307', '\u0308', '\u0309', '\u030A', '\u030B',
  '\u030C', '\u030D', '\u030E', '\u030F', '\u0310', '\u0311',
  '\u0312', '\u0313', '\u0314', '\u0315', '\u031A', '\u033D',
  '\u0347', '\u0358', '\u035C', '\u035F', '\u0361', '\u0489'
];

// Retro terminal / glitchy Unicode glyphs
const retroGlyphs = [
  '█', '▓', '▒', '░', '■', '▐', '▌', '▯', '▮', '▪', '▫',
  '⫷', '⫸', '⊶', '⊷', '⟊', '⟿', '⫰', '⫱', '⨌', '⨂',
  'Ƹ', 'ƛ', 'Ʃ', 'ȹ', '☠', '⚙', '⌘', '⌧'
];

// Fullwidth and oddball chars
const fullwidthChars = ["ａ", "ｂ", "5", "3", "J", "U", "M", "P"];

// Basic alphanumeric base
const baseChars = "BASEJUMPbasejumpBROADSIDE";
// "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

// Zalgo generator
export function generateZalgoGlitch(length = 10) {
  let result = "";
  for (let i = 0; i < length; i++) {
    const char = baseChars[Math.floor(Math.random() * baseChars.length)];
    const numMarks = 1 + Math.floor(Math.random() * 5);
    const glitch = Array.from(
      { length: numMarks },
      () => zalgoMarks[Math.floor(Math.random() * zalgoMarks.length)]
    ).join("");
    result += char + glitch;
  }
  return result;
}

// Retro terminal glyph generator
export function generateRetroTerminalVomit(length = 10) {
  let result = "";
  for (let i = 0; i < length; i++) {
    result += retroGlyphs[Math.floor(Math.random() * retroGlyphs.length)];
  }
  return result;
}

// Mixed glitch generator
export function generateMixedGlitch(length = 10) {
  let result = "";
  for (let i = 0; i < length; i++) {
    const mode = Math.random();
    if (mode < 0.7) {
      // Zalgo glitch char
      const base = baseChars[Math.floor(Math.random() * baseChars.length)];
      const numMarks = 1 + Math.floor(Math.random() * 4);
      const marks = Array.from(
        { length: numMarks },
        () => zalgoMarks[Math.floor(Math.random() * zalgoMarks.length)]
      ).join("");
      result += base + marks;
    } else if (mode < 0.87) {
      // Retro symbol
      result += retroGlyphs[Math.floor(Math.random() * retroGlyphs.length)];
    } else if (mode < 0.885) {
      // Alphanumeric char
      result += "BASE";
    } else if (mode < 0.9) {
      // Alphanumeric char
      result += "JUMP";
    } else {
      // Fullwidth or symbolic
      result +=
        fullwidthChars[Math.floor(Math.random() * fullwidthChars.length)];
    }
  }
  return result;
}
